import * as Bluebird from 'bluebird';
import * as moment from 'moment';
import { Episode, EpisodeStatus } from './../../types';
import AnchorAPIError from './AnchorAPIError';

const decodeEpisodeJsonIntoEpisodeStatus = (
  episodeJson: any
): EpisodeStatus => {
  const now = moment(new Date());
  if (moment(episodeJson.publishOn).isAfter(now)) {
    return {
      kind: 'scheduledToBePublished',
      date: moment(episodeJson.publishOn).toDate(),
    };
  }
  if (episodeJson.publishOn) {
    return {
      kind: 'published',
      date: moment(episodeJson.publishOn).toDate(),
      fullEpisodeAudioFileUrl: episodeJson.url,
    };
  }
  if (!episodeJson.publishOn) {
    return {
      kind: 'savedAsDraft',
      date: moment(episodeJson.created).toDate(),
    };
  }
  throw new Error('decodeEpisodeJsonIntoEpisodeStatus issue');
};

const decodeResponseIntoEpisodes = (json: any): Episode[] =>
  json.podcastEpisodes
    .map(
      (jsonEpisode: any): Episode => ({
        adsCount: jsonEpisode.adCount,
        id: {
          kind: 'webId',
          webId: jsonEpisode.podcastEpisodeId,
        },
        lengthInMs: jsonEpisode.duration,
        playCount: jsonEpisode.downloads,
        publicUrlPath: jsonEpisode.shareLinkPath,
        status: decodeEpisodeJsonIntoEpisodeStatus(jsonEpisode),
        title: jsonEpisode.title,
      })
    )
    // This function should be available in the `Episode` model... introduced in a later PR
    .sort((a: Episode, b: Episode) => {
      return (
        new Date(b.status.date).getTime() - new Date(a.status.date).getTime()
      );
    });

// TODO: This endpoint can only support fetching up to 1000 episodes.
//       We should migrate this fetch to hit our main api
const fetchEpisodes = (page?: number, limit?: number) =>
  new Promise<Episode[]>((resolve, reject) => {
    const baseUrl = `/api/podcastepisode`;
    const url = `${baseUrl}${
      page && limit ? `?page=${page}&limit=${limit}` : '?page=1&limit=1000'
    }`;
    fetch(url, {
      method: 'GET',
    }).then(
      (response: any): void => {
        if (response.ok) {
          response.json().then((responseJson: any) => {
            // TODO: We should ad runtime checking to verify that the json can be converted to Episode[]
            const episodes = decodeResponseIntoEpisodes(responseJson);
            resolve(episodes);
          });
        } else {
          const error = new AnchorAPIError(response, 'Server error.');
          reject(error);
        }
      }
    );
  });

export { fetchEpisodes };
